//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import TraitsTable from "@/pages/StoreManagement/components/traitsTable.vue";
import GeographyTable from "@/pages/StoreManagement/components/geographyTable.vue";
import TraitsTab from "@/pages/StoreManagement/components/traitsTab.vue";
import GeographyTab from "@/pages/StoreManagement/components/geographyTab.vue";
// import TagsTab from "@/pages/StoreManagement/components/tagsTab.vue";
import ReplacementCodes from "@/pages/StoreManagement/components/replacementCodesTab.vue"


const EMPTY_STORE = {
  hierarchy: [{ id: null }, { id: null }, { id: null }],
  geography: [{ id: null }, { id: null }, { id: null }],
  least_hierarchy_level_id: null,
  least_geo_level_id: null,
  // tags: [],
};

export default {
  name: "StoreManagement",
  components: {
    TraitsTable,
    GeographyTable,
    TraitsTab,
    GeographyTab,
    // TagsTab,
    ReplacementCodes
  },
  mounted: function () {
    this.fetchStores()
  },
  data: () => ({
    data: [],
    traitsForm: false,
    geographyForm: false,
    frequencyForm: false,
    codesForm: false,
    tableTab: "traits",
    tab: "traits",
    filterState: null,
    rightSidePane: false,
    separator: "cell",
    store: {
      least_hierarchy_level_id: null,
      least_geo_level_id: null,
    },
    recordsTotal: null,
    isLoading: false,
  }),
  methods: {
    fetchStores() {
      this.isLoading = true;
      BackendServices.getStores().then((response) => {
        this.recordsTotal = Number(response.headers["x-total-count"]);
        this.data = response.data;
        this.isLoading = false;
      });
    },
    createNewStore: function () {
      this.rightSidePane = true;
      this.traitsForm = false;
      this.geographyForm = false;
      this.frequencyForm = false;
      this.store = EMPTY_STORE;
      // if (!this.store.tags.length) {
      //   for (let i = 0; i < 5; i++) {
      //     this.store.tags.push({
      //       id: null,
      //       key: null,
      //       value: null,
      //       tag_type: "user",
      //     });
      //   }
      // }
    },
    askForData: function (event) {
      this.isLoading = true;
      BackendServices.getStores(
        event.pagination,
        event.filter,
        false, event.search).then(
          (response) => {
            this.recordsTotal = response.headers["x-total-count"];
            if (response.headers["x-total-count"] === "0") {
              this.data = [];
            } else {
              this.data = response.data;
            }
            this.isLoading = false;
          }
        );
    },
    openExistingStore: function (event) {
      this.rightSidePane = true;
      this.store = event;
      // let newItems =
      //   5 -
      //   this.store.tags.filter(
      //     (i) => i.tag_type === "user" && i.key != null && i.value != null
      //   ).length;
      // let totalUserTags = this.store.tags.filter(
      //   (i) => i.tag_type === "user"
      // ).length;
      // for (let i = 0; i < newItems && totalUserTags < 5; i++) {
      //   this.store.tags.push({
      //     id: null,
      //     key: null,
      //     value: null,
      //     tag_type: "user",
      //   });
      // }
      this.traitsForm = true;
      this.geographyForm = true;
      this.frequencyForm = true;
    },
    closeForm: function () {
      this.rightSidePane = false;
      this.store = {};
    },
    saveStore: function () {
      // this.store.tags = this.store.tags.filter(
      //   (item) => item.key && item.value
      // );
      let operation = !this.store.id
        ? BackendServices.createNewStore(this.store)
        : BackendServices.updateManagementStore(this.store);
      operation.then(() => window.location.reload());
    },
    removeStore: function (store) {
      BackendServices.deleteStore(store).then(() => {
        this.fetchStores()
        this.$q.notify({ message: "Loja removida!", color: "green" })

      }).catch((error) => {
        if (error.response.status === 405) {
          this.$q.notify({ message: "Loja não pode ser removida!", color: "red" })
        } else {
          this.$q.notify({ message: error.response.data.error, color: "red" })
        }
      }
      );
      // BackendServices.deleteStore(store)
      //   .then(() => window.location.reload())
      //   .catch((error) =>
      //     this.$q.notify({ message: error.response.data.error, color: "red" })
      //   );
      // this.fetchStores()
      //     this.$q.notify({ message: "Loja removida!", color: "green" })
    },
    exportFilteredStores: function () {
      let filters = [];
      if (this.filterState) {
        Object.values(this.filterState).forEach((value) => {
          if (value.include && value.include.length > 0) {
            filters.push({ key: value.column_key, values: value.include });
          }
        });
      }
      BackendServices.downloadStoreList(filters.length ? filters : null).then(
        (response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "Stores.xlsx"); //any other extension
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      );
    },
  },
};
